//import "react-app-polyfill/ie11";
//import "react-app-polyfill/stable";

import * as jQuery from "jquery/dist/jquery";
import Bootstrap from "bootstrap/dist/js/bootstrap";

//import "./sass/main.scss";
//import "./sass/bdg.scss";
//import "./sass/boxxca.scss";
//import "./sass/website.scss";

//import Flickity from 'flickity'; // use instead /scripts/flickity/flickity.pkgd.custom.min

import 'flickity-imagesloaded';
import 'flickity-as-nav-for';

import * as React from "react";
import  { Suspense } from "react";
//import ReactDOM from 'react-dom';
import "regenerator-runtime/runtime.js";
import { Provider as ReduxProvider } from "react-redux";

import FormComponent from "./components/formBuilder/formComponent";
import Form2StepsComponent from "./components/formBuilder/form2StepsComponent";
import FormModalComponent from "./components/formBuilder/formModalComponent";
import HomeFormModalComponent from "./components/formBuilder/homeFormModalComponent";
import LoadingIndicator from "./components/LoadingIndicator";
import NewsPressMediaListing from './components/NewsPressMediaListing';
import ResourcesPage from "./components/ResourcesPage";
import SiteSearchPage from "./components/SiteSearchPage";
import SearchWithSuggestions from './components/SearchWithSuggestions';
import UsedListingPage from "./components/UsedListingPage";
import FloorplanListingPage from "./components/FloorplanListingPage";
import InvestorNewPage from "./components/InvestorNewsPage";
import configureStore from './store/configureStore';

//import SampleReduxComponent from "./components/SampleReduxComponent";
//import SearchPdPage from "./components/search/SearchPdPage";

const store = configureStore(history);
const globalAny: any = global;
globalAny.bootstrap = Bootstrap;
globalAny.jQuery = jQuery;
//globalAny.Flickity = Flickity;
//global.React = React;
//global.ReactDOM = ReactDOM;

//global.SampleReduxComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><ReduxProvider store={store}><SampleReduxComponent {...props} /></ReduxProvider></Suspense>);
//global.SearchPdPage = (props) => (<Suspense fallback={<LoadingIndicator />}><ReduxProvider store={store}><SearchPdPage {...props} /></ReduxProvider></Suspense>);

globalAny.Form2StepsComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><Form2StepsComponent {...props} /></Suspense>);
globalAny.FormComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><FormComponent {...props} /></Suspense>);
globalAny.FormModalComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><FormModalComponent {...props} /></Suspense>);
globalAny.HomeFormModalComponent = (props) => (<Suspense fallback={<LoadingIndicator />}><HomeFormModalComponent {...props} /></Suspense>);
globalAny.LoadingIndicator = LoadingIndicator;
globalAny.NewsPressMediaListing = (props) => (<Suspense fallback={<LoadingIndicator />}><NewsPressMediaListing {...props} /></Suspense>);
globalAny.ResourcesPage = (props) => (<Suspense fallback={<LoadingIndicator />}><ResourcesPage {...props} /></Suspense>);
globalAny.SiteSearchPage = (props) => (<Suspense fallback={<LoadingIndicator />}><ReduxProvider store={store}><SiteSearchPage {...props} /></ReduxProvider></Suspense>);
globalAny.SearchWithSuggestions = (props) => (<Suspense fallback={<LoadingIndicator />}><ReduxProvider store={store}><SearchWithSuggestions {...props} /></ReduxProvider></Suspense>);
globalAny.UsedListingPage = (props) => (<Suspense fallback={<LoadingIndicator />}><UsedListingPage {...props} /></Suspense>);
globalAny.FloorplanListingPage = (props) => (<Suspense fallback={<LoadingIndicator />}><FloorplanListingPage {...props} /></Suspense>);
globalAny.InvestorNewsPage = (props) => (<Suspense fallback={<LoadingIndicator />}><InvestorNewPage {...props} /></Suspense>);

export default global;